import React from 'react';
import Hero from './Hero';
import Partners from './Partners';
import About from './About';
import Products from './Products';
import Services from './Services';
import Ezofis from './Ezofis';
import Industries from './Industries';
import WhyChoose from './WhyChoose';

export default function Home() {
  return (
    <>
      <Hero />
      <Partners />
      <About />
      <Products />
      <Services />
      <Ezofis />
      <Industries />
      <WhyChoose />
    </>
  );
}
